import { createSelector } from '@reduxjs/toolkit';

const selectScheduleState = (state) => state.schedule;

export const selectSelectedDate = createSelector(
  selectScheduleState,
  (schedule) => schedule.selectedDate
);

export const selectSheets = createSelector(
  selectScheduleState,
  (schedule) => schedule.sheets || []
);

/**
 * Sheets visible for the current selected date (time-based views).
 */
export const selectVisibleSheetsForDate = createSelector(
  [selectSheets],
  (sheets) => sheets
);

/**
 * Sheets with a valid grid position, used by the grid view.
 */
export const selectVisibleGridSheets = createSelector(
  [selectSheets],
  (sheets) =>
    sheets.filter((entry) => Number.isInteger(entry.grid?.position))
);

